<template>
  <div><!-- Razorpay uses its own overlay modal, no custom markup needed --></div>
</template>

<script setup>
import { watch, onUnmounted } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  orderData: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['update:visible', 'success', 'error']);

let razorpayInstance = null;

const openRazorpay = () => {
  if (!props.orderData || !window.Razorpay) {
    emit('error', { message: 'Razorpay SDK not loaded or order data missing' });
    emit('update:visible', false);
    return;
  }

  const isSubscription = props.orderData.type === 'subscription';

  const options = {
    key: props.orderData.razorpay_key_id,
    name: 'SuperAGI',
    description: isSubscription ? `Auto recharge ${props.orderData.credit_count} credits/month` : `Purchase ${props.orderData.credit_count} credits`,
    theme: {
      color: '#7C3AED',
    },
    modal: {
      ondismiss: function () {
        emit('error', { message: 'Payment cancelled by user' });
        emit('update:visible', false);
      },
    },
  };

  if (isSubscription) {
    options.subscription_id = props.orderData.razorpay_subscription_id;
    options.handler = function (response) {
      emit('success', {
        type: 'subscription',
        razorpay_subscription_id: response.razorpay_subscription_id,
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature,
      });
      emit('update:visible', false);
    };
  } else {
    options.amount = props.orderData.amount_paise;
    options.currency = props.orderData.currency || 'INR';
    options.order_id = props.orderData.razorpay_order_id;
    options.handler = function (response) {
      emit('success', {
        type: 'order',
        razorpay_order_id: response.razorpay_order_id,
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_signature: response.razorpay_signature,
      });
      emit('update:visible', false);
    };
  }

  razorpayInstance = new window.Razorpay(options);
  razorpayInstance.open();
};

watch([() => props.visible, () => props.orderData], ([visible, orderData]) => {
  if (visible && orderData) {
    openRazorpay();
  }
});

onUnmounted(() => {
  if (razorpayInstance) {
    razorpayInstance.close();
  }
  razorpayInstance = null;
});
</script>
